export enum OwnerStatus {
  Active = "a",
  NonOwner = "u",
  OnHold = "h",
  NotActive = "n",
}

export enum DriverStatus {
  Active = "working",
  NotActive = "not-working",
  OnHold = "hold",
  OnSilentHold = "silent-hold",
  NotDriver = "not-driver",
}

export const DriverStatusOnHold = [DriverStatus.OnHold, DriverStatus.OnSilentHold];
